module.exports = __webpack_public_path__ + "img/tbLeatherQRCode.6dbeb003.png";